/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
type BuySharedBreadcrumbs_buyPage$ref = any;
type BuySharedDescription_buyPage$ref = any;
type BuySharedHead_buyPage$ref = any;
type BuySharedMoreWaysToBrowse_internalBuyLinks$ref = any;
type BuySharedMoreWaysToBrowse_viewer$ref = any;
type BuySharedNullSearchResults_buyPage$ref = any;
type BuySharedNullSearchResults_viewer$ref = any;
type BuySharedPagination_buyPage$ref = any;
type BuySharedResultContainer_buyPage$ref = any;
type BuySharedResultContainer_viewer$ref = any;
type BuySharedTitle_buyPage$ref = any;
export type BuySharedLayout_viewer$ref = any;
export type BuySharedLayout_viewer = {
    readonly buyPage: {
        readonly totalResults: number | null;
        readonly tracking: {
            readonly pageSection: string | null;
        } | null;
        readonly internalBuyLinks: ReadonlyArray<{
            readonly " $fragmentRefs": BuySharedMoreWaysToBrowse_internalBuyLinks$ref;
        } | null> | null;
        readonly " $fragmentRefs": BuySharedBreadcrumbs_buyPage$ref & BuySharedTitle_buyPage$ref & BuySharedResultContainer_buyPage$ref & BuySharedPagination_buyPage$ref & BuySharedDescription_buyPage$ref & BuySharedHead_buyPage$ref & BuySharedNullSearchResults_buyPage$ref;
    } | null;
    readonly " $fragmentRefs": BuySharedResultContainer_viewer$ref & BuySharedNullSearchResults_viewer$ref & BuySharedMoreWaysToBrowse_viewer$ref;
    readonly " $refType": BuySharedLayout_viewer$ref;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "BuySharedLayout_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "uriRef",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "localeOrigin",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "first",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "page",
      "type": "Int"
    },
    {
      "kind": "RootArgument",
      "name": "rootId",
      "type": "String"
    }
  ],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "buyPage",
      "storageKey": null,
      "args": [
        {
          "kind": "Variable",
          "name": "first",
          "variableName": "first"
        },
        {
          "kind": "Variable",
          "name": "localeOrigin",
          "variableName": "localeOrigin"
        },
        {
          "kind": "Variable",
          "name": "page",
          "variableName": "page"
        },
        {
          "kind": "Variable",
          "name": "rootId",
          "variableName": "rootId"
        },
        {
          "kind": "Variable",
          "name": "uriRef",
          "variableName": "uriRef"
        }
      ],
      "concreteType": "BuyPageConnection",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "totalResults",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "tracking",
          "storageKey": null,
          "args": null,
          "concreteType": "TrackingType",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "alias": null,
              "name": "pageSection",
              "args": null,
              "storageKey": null
            }
          ]
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "internalBuyLinks",
          "storageKey": null,
          "args": null,
          "concreteType": "InternalBuyLinkType",
          "plural": true,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "BuySharedMoreWaysToBrowse_internalBuyLinks",
              "args": null
            }
          ]
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedBreadcrumbs_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedTitle_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedResultContainer_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedPagination_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedDescription_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedHead_buyPage",
          "args": null
        },
        {
          "kind": "FragmentSpread",
          "name": "BuySharedNullSearchResults_buyPage",
          "args": null
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedResultContainer_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedNullSearchResults_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "BuySharedMoreWaysToBrowse_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'c76f827cf5f2c9edd2899bf5be48acb3';
export default node;
